import { ReactNode } from 'react';

interface LayoutProps {
  children?: ReactNode;
}

export const MaxWidth = ({ children }: LayoutProps) => (
  <div className="container mx-auto">{children}</div>
);

export const Target = ({ children }: LayoutProps) => (
  <div className="h-full flex items-center justify-center">
    <div className="flex-grow">{children}</div>
  </div>
);
